export default {
  name: 'CalendarDayRecord',
  props: {
    record: {
      type: Object
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    },
    editable: {
      type: Boolean
    }
  },
  computed: {
    users () {
      return this.scheduleData.users;
    },
    schedule () {
      for (const key in this.scheduleData.schedules) {
        if (this.scheduleData.schedules[key].id == this.record.schedule_id) {
          return this.scheduleData.schedules[key];
        }
      }
    },
    userName: function () {
      const scheduleKey = this.schedule.department_id + (this.schedule.division_id ? '_' + this.schedule.division_id : '');

      if (this.users[scheduleKey] && this.users[scheduleKey][this.record.user_id]) {
        return this.users[scheduleKey][this.record.user_id].fullname;
      }
    },
    shift () {
      for (const key in this.scheduleData.shifts) {
        if (this.scheduleData.shifts[key].id == this.record.shift_id) {
          return this.scheduleData.shifts[key];
        }
      }
    },
    team () {
      if (this.shift && this.shift.team_id) {
        for (const key in this.scheduleData.teams) {
          if (this.scheduleData.teams[key].id == this.shift.team_id) {
            return this.scheduleData.teams[key];
          }
        }
      }
    }
  },
  methods: {
    editRecord: function () {
      this.record.department_id = this.schedule.department_id;
      this.record.division_id = this.schedule.division_id;
      this.record.type = this.filterData.type;
      this.$emit('editRecord', { record: this.record, isCalendarView: false });
    }
  }
}
